var infraestructuras = angular.module('infraestructuras');

infraestructuras.factory('infraestructurasService', ['$http', '__env', function infraestructurasService($http, __env) {

    var serviceUrl = __env.apiUrl;
    var infraestructurasUrl = 'categorias';
    var dañosUrl = 'damages';
    var informesUrl = 'informes';
    var dañoUrl = 'damage';
    var chatboxUrl = 'ChatBox';

    function getCategorias() {
        return $http.get(serviceUrl + infraestructurasUrl);
    }

    function getCategoria(idCategoria) {
        return $http.get(serviceUrl + infraestructurasUrl + '/' + idCategoria);
    }

    function getDatosGalibos() {
        return $http.get(serviceUrl + "galibos");
    }

    function getUltimaInspeccionPorTunel(idTunel) {
        return $http.get(serviceUrl + dañosUrl + "/tunel/" + idTunel);
    }

    function getTodasLasInspecciones(idCategoria) {
        return $http.get(serviceUrl + '/infraestructuras/all/' + idCategoria);
    }

    function getInforme(idInspeccion) {
        return $http({
            url: serviceUrl + informesUrl + "/informeinspeccion/" + idInspeccion,
            method: 'post',
            responseType: 'blob',
            headers: { 'Content-Type': undefined }
        });
    }

    function getListado(idInspeccion) {
        return $http({
            url: serviceUrl + informesUrl + "/listadoinspeccion/" + idInspeccion,
            method: 'post',
            responseType: 'blob',
            headers: { 'Content-Type': undefined }
        });
    }

    function getDañosPorTipo(idInspeccion) {
        return $http.get(serviceUrl + dañosUrl + "/damagesportipo/" + idInspeccion);
    }

    function getDañosPorGravedad(idInspeccion) {
        return $http.get(serviceUrl + dañosUrl + "/damagesporgravedad/" + idInspeccion);
    }


    // silvia para tuneles


    function getDañosPorGravedadTodosLosTuneles(id, usuario) {
        return $http({
            method: 'get',
            url: serviceUrl + '/infraestructuras/tuneles/damagesporgravedad/categoria/' + id,
            params:
            {
                'usuario': usuario
            }
        });
    }

    function getDañosPorElemento(idInspeccion) {
        return $http.get(serviceUrl + dañosUrl + "/damagesporelemento/" + idInspeccion);
    }

    //function getDañosPorSeccion(idInspeccion, distSeccion) {
    //    return $http.get(serviceUrl + dañosUrl + "/damagesporseccion/" + idInspeccion + "/" + distSeccion);
    //}

    function getResumenPorSeccion(idInspeccion, distSeccion) {
        return $http.get(serviceUrl + dañosUrl + "/resumenporseccion/" + idInspeccion + "/" + distSeccion);
    }

    function getInfraestructurasCategoria(id, usuario) {
        return $http({
            method: 'get',
            url: serviceUrl + 'infraestructuras/categoria/' + id,
            params:
            {
                'usuario': usuario
            }
        });
    }






    function getInfraestructuraPorGravedad(idCategoria) {
        return $http({
            method: 'get',
            url: serviceUrl + '/infraestructuras/infraestructurasporgravedad/' + idCategoria,
        });
    }


    // fin silvia para tuneles


    function getInfraestructura(id) {
        return $http.get(serviceUrl + '/infraestructuras/' + id);
    }

    function getTiposTunel() {
        return $http.get(serviceUrl + "tiposTunel");
    }

    function getObstaculos() {
        return $http.get(serviceUrl + "obstaculo");
    }

    function getObstaculos() {
        return $http.get(serviceUrl + "obstaculo");
    }

    function getNumDireccionesTunel() {
        return $http.get(serviceUrl + "numDireccionesTunel");
    }

    function getLongitudTunel() {
        return $http.get(serviceUrl + "longitudTunel");
    }

    function getMaterialesTunel() {
        return $http.get(serviceUrl + "materialTunel");
    }

    function getTipoVia() {
        return $http.get(serviceUrl + "tipoVia");
    }

    function getCirculacionPermitida() {
        return $http.get(serviceUrl + "circulacionPermitida");
    }

    function getTunel(idInfraestructura) {
        return $http.get(serviceUrl + "tuneles/" + idInfraestructura);
    }

    function guardarInventario(Id, tunel, COD_INT, propietarioId, entornoId, municipioId) {
        return $http({
            method: 'put',
            url: serviceUrl + 'tuneles/put/' + Id,
            params:
            {
                //'strTunel': JSON.stringify(tunel),
                'COD_INT': COD_INT,
                'propietarioId': propietarioId,
                'entornoId': entornoId,
                'municipioId': municipioId
            },
            data: tunel,
            headers: { 'Content-Type': undefined },

        });
    }


    function getPresa(idInfraestructura) {
        return $http.get(serviceUrl + "presas/" + idInfraestructura);
    }



    function verInspeccion(idInspeccion) {
        return $http.get(serviceUrl + "inspecciones/" + idInspeccion);
    }


    function getInspeccion(idInspeccion) {
        return $http.get(serviceUrl + "inspeccion/" + idInspeccion);
    }

    function getInspecciones(idTunel) {
        return $http.get(serviceUrl + "inspecciones/tunel/" + idTunel);
    }

    function guardarInspeccion(inspeccion) {
        return $http.put(serviceUrl + 'inspecciones/put/' + inspeccion.Id, inspeccion);
    }

    function getChatBox(pregunta) {
        return $http({
            method: 'post',
            url: serviceUrl + chatboxUrl,
            params: {
                'request': pregunta
            }
        });
    }




    return {
        getCategorias: getCategorias,
        getInfraestructurasCategoria: getInfraestructurasCategoria,
        getInfraestructura: getInfraestructura,
        getCategoria: getCategoria,
        getTiposTunel: getTiposTunel,
        getObstaculos: getObstaculos,
        getNumDireccionesTunel: getNumDireccionesTunel,
        getLongitudTunel: getLongitudTunel,
        getMaterialesTunel: getMaterialesTunel,
        getTipoVia: getTipoVia,
        getCirculacionPermitida: getCirculacionPermitida,
        getTunel: getTunel,
        guardarInventario: guardarInventario,
        guardarInspeccion: guardarInspeccion,
        getInspeccion: getInspeccion,
        getDatosGalibos: getDatosGalibos,
        guardarInspeccion: guardarInspeccion,
        getInspecciones: getInspecciones,
        verInspeccion: verInspeccion,
        getUltimaInspeccionPorTunel: getUltimaInspeccionPorTunel,
        getDañosPorTipo: getDañosPorTipo,
        getDañosPorGravedad: getDañosPorGravedad,
        getInforme: getInforme,
        getChatBox: getChatBox,
        getDañosPorElemento: getDañosPorElemento,
        getResumenPorSeccion: getResumenPorSeccion,
        getDañosPorGravedadTodosLosTuneles: getDañosPorGravedadTodosLosTuneles,
        getInfraestructuraPorGravedad: getInfraestructuraPorGravedad,
        getListado: getListado,
        getTodasLasInspecciones: getTodasLasInspecciones,
        //getDañosPorSeccion: getDañosPorSeccion
        getPresa:  getPresa
    }

}]);

